import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (project) =>
    present(
      repository
        .getProjectResources(project)
        .then((projectResources) => ({ project, projectResources }))
        .catch(() => Promise.reject(project)),
    );
}

export type { Interactor };

export { createInteractor };
